import { Link } from "react-router-dom";
import type { ShortFilm } from "@/mocks/shortFilms";
import { formatDate } from "@/utils/format";

interface ShortFilmCardProps {
  film: ShortFilm;
}

export default function ShortFilmCard({ film }: ShortFilmCardProps) {
  return (
    <Link to={`/detail/shortfilm/${film.id}`} className="group block cursor-pointer">
      <div className="relative w-full aspect-video overflow-hidden rounded-lg bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title}短片封面`}
          title={`${film.title} - 小电影影视短片`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/5 to-transparent" />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-[11px] font-medium">
          {film.type}
        </span>
        <span className="absolute bottom-2.5 right-2.5 px-1.5 py-0.5 rounded bg-foreground-950/70 text-background-100 text-[11px] font-label">
          {film.duration} 分钟
        </span>
      </div>
      <h3 className="mt-3 text-[15px] leading-6 font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
        {film.title}
      </h3>
      <p className="mt-1 text-[13px] leading-relaxed text-foreground-600 line-clamp-2">
        {film.tagline}
      </p>
      <div className="mt-2.5 flex items-center justify-between text-xs text-foreground-500">
        <span className="truncate">导演 {film.director}</span>
        <span className="shrink-0 ml-2 font-label">{formatDate(film.publishDate)}</span>
      </div>
    </Link>
  );
}